import useUser from "../../../../../../../../hooks/useUser";
import InstanceDetailCol1 from "./components/InstanceDetailCol1";
import InstanceDetailCol2 from "./components/InstanceDetailCol2";
import InstanceDetailCol3 from "./components/InstanceDetailCol3";
import InstanceDetailCol4 from "./components/InstanceDetailCol4";

const InstanceDetail = ({ formik }) => {
  const { hasPermission } = useUser();
  const isDisabled = !hasPermission("UPDATE_INSTANCE");

  return (
    <div
      className={`grid w-full grid-cols-1 gap-4 border-t border-gray-200 pt-4 sm:grid-cols-2 sm:gap-6 sm:pt-6 lg:grid-cols-4 lg:gap-8 lg:pt-8`}
    >
      <InstanceDetailCol1
        formik={formik}
        isDisabled={isDisabled}
        submitOnBlur={true}
      />
      <InstanceDetailCol2
        formik={formik}
        isDisabled={isDisabled}
        submitOnBlur={true}
      />
      <InstanceDetailCol3
        formik={formik}
        isDisabled={isDisabled}
        submitOnBlur={true}
      />
      <InstanceDetailCol4
        formik={formik}
        isDisabled={isDisabled}
        submitOnBlur={true}
      />
    </div>
  );
};

export default InstanceDetail;
